import {
  Athul_Reji,
  George_Sabu,
  Jagannath_E_Shahi,
  Jessica_Jolly,
  SharatJacob,
} from "../assets/team/teamImages";

const execData = [
  {
    id: 1,
    name: "George Sabu",
    image: George_Sabu,
    linkedIn: "https://www.linkedin.com/in/george-sabu-63370717a",
  },
  {
    id: 2,
    name: "Athul Reji",
    image: Athul_Reji,
    linkedIn: "https://www.linkedin.com/in/athul-reji-a99ab2201",
  },
  {
    id: 3,
    name: "Jagannath E Sahi",
    image: Jagannath_E_Shahi,
    linkedIn: "https://www.linkedin.com/in/jagannath-e-shahi-3b0525202",
  },
  {
    id: 4,
    name: "Sharat Jacob",
    image: SharatJacob,
    linkedIn: "https://www.linkedin.com/in/sharat-jacob-jacob",
  },
  {
    id: 5,
    name: "Jessica Jolly",
    image: Jessica_Jolly,
    linkedIn: "https://www.linkedin.com/in/jessica-jolly-b424841aa/",
  },
];

export default execData;
